<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
  },
  components: {
    Layout: () => import("./Layout.vue"),
  },
  data() {
    return {
      tabActive: 0,
    };
  },
  methods: {
    onTabChanged(index) {
      for (let i = 0; i < this.tabs.length; i++) {
        const tab = this.tabs[i];
        if (index === i) {
          tab.isActive = true;
        } else {
          tab.isActive = false;
        }
      }
    },
  },
  mounted() {
    this.onTabChanged(0);
  },
  created() {
    this.onTabChanged(0);
  },
};
</script>
<template>
  <b-tabs
    v-if="tabs.length > 1"
    v-model="tabActive"
    nav-class="nav-tabs-custom col-4 p-0 ul-width"
    content-class="text-muted"
  >
    <b-tab
      v-for="(tab, index) in tabs"
      :key="index"
      :title="tab.title"
      @click="onTabChanged(index)"
    >
      <b-card-text>
        <Layout
          v-if="tab.isActive"
          :layout="tab"
          :setTopbarControls="setTopbarControls"
          :active="tab.isActive"
          :topbarControls="topbarControls"
        />
      </b-card-text>
    </b-tab>
  </b-tabs>
  <b-card-text v-else>
    <Layout
      v-if="tabs[0].isActive"
      :layout="tabs[0]"
      :setTopbarControls="setTopbarControls"
      :active="tabs[0].isActive"
      :topbarControls="topbarControls"
    />
  </b-card-text>
</template>
<style>
.ul-width {
  width: calc(100% - 69%) !important;
}
</style>
